import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  BlueprintsListComponent,
  BlueprintFormComponent,
  BlueprintMapsListComponent,
  BlueprintMapEditComponent,
  BlueprintMapMappingComponent
} from '../upgrade/blueprints.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, featureGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const blueprintsRoutes: Routes = [
  {
    path: 'blueprints',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    data: {
      permission: 'blueprints.view'
    },
    children: [
      {
        path: 'blah',
        loadChildren: () => import('@fry-it/risr-features/blueprints-management').then(m => m.blueprintRoutes as Routes),
      },
      {
        path: '',
        component: BlueprintsListComponent,
        data: {
          state: 'epf.blueprints.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: BlueprintFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'blueprints.edit',
          state: 'epf.blueprints.new'
        }
      },
      {
        path: 'edit/:id',
        component: BlueprintFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'blueprints.edit',
          state: 'epf.blueprints.edit'
        }
      }
    ]
  },
  {
    path: 'blueprint-maps',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, featureGuard],
    data: {
      permission: 'blueprints.view',
      feature: 'blueprint-maps'
    },
    children: [
      {
        path: '',
        component: BlueprintMapsListComponent,
        data: {
          state: 'epf.blueprint-maps.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: BlueprintMapEditComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'blueprints.edit',
          state: 'epf.blueprint-maps.new',
          action: 'new'
        }
      },
      {
        path: ':id/edit',
        component: BlueprintMapEditComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'blueprints.edit',
          state: 'epf.blueprint-maps.edit',
          action: 'edit'
        }
      },
      {
        path: ':id/mapping',
        component: BlueprintMapMappingComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'blueprints.edit',
          state: 'epf.blueprint-maps.mapping'
        }
      }
    ]
  }
];
